import "@/App.css";
import "@/polish-fx.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CursorGlow from "@/components/CursorGlow";
import MotionPolish from "@/components/MotionPolish";
import StickyCTA from "@/components/StickyCTA";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import WhyVIRALX from "@/components/WhyVIRALX";
import Testimonials from "@/components/Testimonials";
import Results from "@/components/Results";
import FeaturedCoaches from "@/components/FeaturedCoaches";
import Team from "@/components/Team";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

const Landing = () => (
  <main data-testid="landing-page" className="fx-polish relative bg-[#f3f1eb] text-[#0a0a0a] min-h-screen">
    <CursorGlow />
    <MotionPolish />
    <StickyCTA />
    <Nav />
    <Hero />
    <FeaturedCoaches />
    <Testimonials />
    <WhyVIRALX />
    <Results />
    <Team />
    <FAQ />
    <Footer />
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
